
import { isAprimo, attachAprimoVideo } from './aprimo-video.js';

jQuery(function($) {
    /**
     * Cart and Checkout Manager
     * Handles cart updates, quantity changes, guest checkout, and cross-sell slider.
     */
    class Pandora_Product_Video {

        /**
         * Constructor.
         */
        constructor() {
            // Debounced version of triggerUpdateCart
            this.eventHandlers();
        }

        /**
         * Bind click events for quantity increase and decrease buttons.
         */
        eventHandlers() {
            $(document.body).ready( this.initVideoControls() );
			$(document.body).on("refresh_video_stream", this.initVideoControls.bind(this));
        }

        /**
		 * Initialize video controls for product gallery.
		 */
		initVideoControls() {
			const $videos = $( '.wishlist-products video, .wishlist-table video, .products video.product-loop-video, .rvp-slider video.product-loop-video, .shop-thelook-slider video, #modal-content .pandora-gallery-img video' );

			$videos.each(function () {
				const $video = $(this);
				const videoEl = this; // DOM element
				const videoUrl = $video.data('video-url');

				// Skip if already initialized
				if (!videoUrl || $video.data('hls-initialized')) return;

				// Aprimo MP4 / HLS. Cloudflare continues to the hls.js code below.
				if (isAprimo(videoUrl)) {
					attachAprimoVideo(videoEl, videoUrl, {
						onReady: () => videoEl.play().catch(err => console.warn('Video play prevented:', err))
					});
					$video.data('hls-initialized', true);
					return;
				}

				if (Hls.isSupported()) {
					const hls = new Hls({
						enableWorker: true,
						lowLatencyMode: true,
						backBufferLength: 90
					});

					hls.loadSource(videoUrl);
					hls.attachMedia(videoEl);

					hls.on(Hls.Events.MANIFEST_PARSED, function () {
						videoEl.muted = true;
						videoEl.loop = true;
						videoEl.playsInline = true;
						videoEl.play();
					});

					hls.on(Hls.Events.ERROR, function (event, data) {
						if (data.fatal) {
							switch (data.type) {
								case Hls.ErrorTypes.NETWORK_ERROR:
									console.error('Network error:', data);
									hls.startLoad();
									break;
								case Hls.ErrorTypes.MEDIA_ERROR:
									console.error('Media error:', data);
									hls.recoverMediaError();
									break;
								default:
									console.error('Fatal error:', data);
									hls.destroy();
									break;
							}
						}
					});

					// Mark as initialized
					$video.data('hls-initialized', true);

				} else if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
					// Native HLS support (Safari)
					videoEl.src = videoUrl;
					videoEl.addEventListener('loadedmetadata', function () {
						videoEl.muted = true;
						videoEl.loop = true;
						videoEl.playsInline = true;
						videoEl.play();
					});
				}
			});

			// Initialize hover videos separately - only play on hover
			this.initHoverVideos();
		}

		/**
		 * Initialize hover videos for archive product grid.
		 * Videos are initialized on first hover and play/pause on hover.
		 */
		initHoverVideos() {
			const $hoverVideos = $( '.products video.gallery-hover-video' );

			$hoverVideos.each(function () {
				const $video = $(this);
				const videoEl = this;
				const videoUrl = $video.data('video-url');
				const $container = $video.closest('.gallery-hover-image-container');

				// Skip if no video URL
				if (!videoUrl) return;

				// Handle hover events on the container
				$container.on('mouseenter', function () {
					// Initialize HLS on first hover if not already done
					if (!$video.data('hls-initialized')) {
						// Aprimo MP4 / HLS. Cloudflare continues to the hls.js code below.
						if (isAprimo(videoUrl)) {
							attachAprimoVideo(videoEl, videoUrl, {
								onReady: () => videoEl.play().catch(err => console.warn('Hover video play prevented:', err))
							});
							$video.data('hls-initialized', true);
							return;
						}

						if (Hls.isSupported()) {
							const hls = new Hls({
								enableWorker: true,
								lowLatencyMode: true,
								backBufferLength: 90
							});

							hls.loadSource(videoUrl);
							hls.attachMedia(videoEl);

							hls.on(Hls.Events.MANIFEST_PARSED, function () {
								videoEl.muted = true;
								videoEl.loop = true;
								videoEl.playsInline = true;
								videoEl.play().catch(err => console.warn('Hover video play prevented:', err));
							});

							hls.on(Hls.Events.ERROR, function (event, data) {
								if (data.fatal) {
									console.error('HLS error:', data);
									hls.destroy();
								}
							});

							$video.data('hls-initialized', true);
							$video.data('hls-instance', hls);

						} else if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
							// Native HLS support (Safari)
							videoEl.src = videoUrl;
							videoEl.muted = true;
							videoEl.loop = true;
							videoEl.playsInline = true;
							videoEl.play().catch(err => console.warn('Hover video play prevented:', err));
							$video.data('hls-initialized', true);
						}
					} else {
						// Already initialized, just play
						videoEl.play().catch(err => console.warn('Hover video play prevented:', err));
					}
				});

				$container.on('mouseleave', function () {
					if ($video.data('hls-initialized')) {
						videoEl.pause();
						videoEl.currentTime = 0;
					}
				});
			});
		}
    }

    // Init
    new Pandora_Product_Video();
});